import { Controller, useFormContext, useWatch } from "react-hook-form";
import { Row, Spacer } from "../../../../components/Layout/Layout";
import { IOrgIntegration } from "../../../../core/api/organizations/types";
import useTranslations from "../../../../core/i18n/useTranslations";
import NumberInput from "../../../../ui-lib/components/Inputs/NumberInput";
import TextInput from "../../../../ui-lib/components/Inputs/TextInput";
import MultiStringInput from "../../../../ui-lib/components/MultiInput/MultiStringInput";

export const CustomSettingsOptionalFields = ({
  settingIndex,
}: {
  settingIndex: number;
}) => {
  const t = useTranslations();

  const {
    formState: { errors },
    control,
    trigger,
  } = useFormContext<IOrgIntegration>();

  const setting = useWatch({
    control,
    name: `expectedUserSettings.${settingIndex}`,
  });

  if (!setting || setting.settingType === "Dynamic") {
    return null;
  }

  return (
    <>
      {setting?.settingType === "String" && (
        <Controller
          control={control}
          rules={{ required: true }}
          name={`expectedUserSettings.${settingIndex}.regex`}
          render={({ field }) => (
            <TextInput
              required
              inputRef={field.ref}
              label={t("Common:regex_value_label")}
              placeholder={t("Organizations:regex_value_placeholder")}
              value={field.value}
              onChange={(e) => {
                field.onChange(e.target.value);
                trigger(`expectedUserSettings.${settingIndex}.regex`);
              }}
              validationError={
                errors.expectedUserSettings?.[settingIndex]?.regex &&
                t("Errors:input_field_required")
              }
            />
          )}
        />
      )}
      {setting?.settingType === "Enum" && (
        <Controller
          control={control}
          rules={{ required: true }}
          name={`expectedUserSettings.${settingIndex}.selectableEnums`}
          render={({ field }) => (
            <MultiStringInput
              required
              label={t("Common:enum_values_label")}
              placeholder={t("Organizations:enum_values_placeholder")}
              values={field.value}
              setValues={(values) => {
                field.onChange(values);
                trigger(`expectedUserSettings.${settingIndex}.selectableEnums`);
              }}
              validationError={
                errors.expectedUserSettings?.[settingIndex]?.selectableEnums &&
                t("Errors:input_field_required")
              }
            />
          )}
        />
      )}
      {setting?.settingType === "Int" && (
        <Row align="start">
          <Controller
            control={control}
            rules={{ required: true }}
            name={`expectedUserSettings.${settingIndex}.minimum`}
            render={({ field }) => (
              <NumberInput
                required
                inputRef={field.ref}
                label={t("Common:min_val")}
                placeholder={t("Organizations:min_val_placeholder")}
                value={field.value?.toString()}
                onChange={(e) => {
                  field.onChange(e.target.value);
                  trigger(`expectedUserSettings.${settingIndex}.minimum`);
                }}
                validationError={
                  errors.expectedUserSettings?.[settingIndex]?.minimum &&
                  t("Errors:input_field_required")
                }
              />
            )}
          />
          <Spacer size={32} />
          <Controller
            control={control}
            rules={{ required: true }}
            name={`expectedUserSettings.${settingIndex}.maximum`}
            render={({ field }) => (
              <NumberInput
                required
                inputRef={field.ref}
                label={t("Common:max_val")}
                placeholder={t("Organizations:max_val_placeholder")}
                value={field.value?.toString()}
                onChange={(e) => {
                  field.onChange(e.target.value);
                  trigger(`expectedUserSettings.${settingIndex}.maximum`);
                }}
                validationError={
                  errors.expectedUserSettings?.[settingIndex]?.maximum &&
                  t("Errors:input_field_required")
                }
              />
            )}
          />
        </Row>
      )}
    </>
  );
};
